import { ApiStudyDto } from 'kes-common';
import React, { Dispatch, SetStateAction } from 'react';

export default React.createContext<{
	setTemplate: Dispatch<SetStateAction<ApiStudyDto>>;
	template: ApiStudyDto;
	refetch(): void;
}>({ setTemplate: () => {}, template: {} as ApiStudyDto, refetch: () => {} });
